import { Form, InputNumber, Select } from 'antd'
import { LineItem } from '../../../../types/ffe'
import { useFFEStore } from '../../../../store/ffeStore'

export const DimensionsPanel = ({ item }: { item: LineItem }) => {
  const updateLineItem = useFFEStore((state) => state.updateLineItem)
  const handleUpdate = (updates: Partial<typeof item>) => {
    updateLineItem(item.id, updates)
  }
  return (
    <div className="p-6">
      <Form layout="vertical">
        <div className="grid grid-cols-2 gap-4 mb-6">
          <Form.Item label="Width">
            <InputNumber
              value={item.dimensions?.width}
              onChange={(value) =>
                handleUpdate({
                  dimensions: {
                    ...item.dimensions,
                    width: value || 0,
                    unit: item.dimensions?.unit || 'mm'
                  }
                })
              }
              className="w-full"
              min={0}
            />
          </Form.Item>

          <Form.Item label="Height">
            <InputNumber
              value={item.dimensions?.height}
              onChange={(value) =>
                handleUpdate({
                  dimensions: {
                    ...item.dimensions,
                    height: value || 0,
                    unit: item.dimensions?.unit || 'mm'
                  }
                })
              }
              className="w-full"
              min={0}
            />
          </Form.Item>

          <Form.Item label="Depth">
            <InputNumber
              value={item.dimensions?.depth}
              onChange={(value) =>
                handleUpdate({
                  dimensions: {
                    ...item.dimensions,
                    depth: value || 0,
                    unit: item.dimensions?.unit || 'mm'
                  }
                })
              }
              className="w-full"
              min={0}
            />
          </Form.Item>

          <Form.Item label="Unit">
            <Select
              value={item.dimensions?.unit || 'mm'}
              onChange={(value) =>
                handleUpdate({
                  dimensions: {
                    ...item.dimensions,
                    unit: value
                  }
                })
              }
              options={[
                { label: 'Millimeters (mm)', value: 'mm' },
                { label: 'Centimeters (cm)', value: 'cm' },
                { label: 'Meters (m)', value: 'm' },
                { label: 'Inches (in)', value: 'in' }
              ]}
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  )
}
